import { createSelector } from 'reselect';
import { initialState } from './chat.reducers';

const selectChat = (state: any) => state.chatReducer || initialState;

const makeSelectMessages = () =>
  createSelector(
    selectChat,
    chatState => chatState.messages,
  );

const makeSelectTotalItems = () =>
  createSelector(
    selectChat,
    chatState => chatState.totalItems,
  );

export { makeSelectMessages, makeSelectTotalItems };
